(function () {
  'use strict';

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(event, container) {
    if (event.key !== 'Tab' || !container) return;
    const elements = Array.from(container.querySelectorAll(FOCUSABLE)).filter((element) => !element.hidden && element.offsetParent !== null);
    if (!elements.length) {
      event.preventDefault();
      container.focus();
      return;
    }
    const first = elements[0];
    const last = elements[elements.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  if (!customElements.get('qenova-mobile-drawer')) {
    class QenovaMobileDrawer extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.qmd__panel');
        this.returnFocus = null;
        document.addEventListener('qmd:open', () => this.open());
        this.querySelectorAll('[data-qmd-close]').forEach(el =>
          el.addEventListener('click', e => { e.preventDefault(); this.close(); })
        );
        document.addEventListener('keydown', e => {
          if (this.hidden) return;
          if (e.key === 'Escape') this.close();
          trapFocus(e, this.panel);
        });
      }
      open() {
        this.returnFocus = document.activeElement;
        this.hidden = false;
        requestAnimationFrame(() => this.setAttribute('data-qmd-open', 'true'));
        document.body.classList.add('qmd-open');
        setTimeout(() => { try { this.panel && this.panel.focus(); } catch (e) {} }, 60);
      }
      close() {
        this.setAttribute('data-qmd-open', 'false');
        document.body.classList.remove('qmd-open');
        setTimeout(() => {
          this.hidden = true;
          if (this.returnFocus && typeof this.returnFocus.focus === 'function') this.returnFocus.focus();
        }, 280);
      }
    }
    customElements.define('qenova-mobile-drawer', QenovaMobileDrawer);
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-qmd-toggle]');
    if (trigger) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('qmd:open'));
    }
  });

  document.addEventListener('click', function (e) {
    const legacy = e.target.closest('summary[aria-label="Menü"], summary[aria-label="Menu"], button[aria-label="Menü"], button[aria-label="Menu"], .header__icon--menu, [data-menu-drawer-toggle]');
    if (!legacy) return;
    if (window.matchMedia('(min-width: 950px)').matches) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    document.dispatchEvent(new CustomEvent('qmd:open'));
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-qcd-close], .qcd__backdrop, .qcd__close')) {
      const drawer = document.querySelector('qenova-cart-drawer');
      if (drawer && !drawer.hidden) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof drawer.close === 'function') {
          drawer.close();
        } else {
          drawer.setAttribute('data-qcd-open', 'false');
          document.body.classList.remove('qcd-open', 'cart-drawer-open');
          setTimeout(function () { drawer.hidden = true; }, 280);
        }
      }
      return;
    }

    const cartTrigger = e.target.closest(
      'cart-drawer-component > button, ' +
      '[aria-label^="Warenkorb öffnen" i], ' +
      '[aria-label^="Open cart" i], ' +
      '.header-actions__cart-icon, ' +
      'a[href="/cart"], a[href$="/cart"]'
    );
    if (!cartTrigger) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    document.dispatchEvent(new CustomEvent('qcd:open'));
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const drawer = document.querySelector('qenova-cart-drawer');
    if (drawer && !drawer.hidden && typeof drawer.close === 'function') drawer.close();
  });

  function hydrateCountrySelect(select) {
    if (!select || select.dataset.countryHydrated === 'true') return;
    const source = select.form?.querySelector('[data-country-options]');
    if (!source) return;
    try {
      const countries = JSON.parse(source.textContent || '[]');
      const fragment = document.createDocumentFragment();
      countries.forEach((country) => {
        const option = document.createElement('option');
        option.value = String(country.value || '');
        option.textContent = String(country.label || country.value || '');
        option.selected = option.value === select.value;
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
      select.dataset.countryHydrated = 'true';
      select.name = select.dataset.countryName || 'country_code';
    } catch (error) {
      console.warn('[qenova-localization]', error);
    }
  }

  document.addEventListener('pointerdown', (event) => {
    const select = event.target.closest?.('[data-country-select]');
    if (select) hydrateCountrySelect(select);
  }, true);
  document.addEventListener('focusin', (event) => {
    if (event.target.matches?.('[data-country-select]')) hydrateCountrySelect(event.target);
  });
  document.addEventListener('change', (event) => {
    if (!event.target.matches?.('[data-country-select], [data-language-select]')) return;
    event.target.form?.requestSubmit();
  });

  document.querySelectorAll('[data-qcp]').forEach(pill => {
    const trigger = pill.querySelector('[data-qcp-trigger]');
    const list = pill.querySelector('[data-qcp-list]');
    if (!trigger || !list) return;
    trigger.addEventListener('click', () => {
      const isOpen = list.hidden === false;
      document.querySelectorAll('[data-qcp-list]').forEach(l => { l.hidden = true; });
      document.querySelectorAll('[data-qcp-trigger]').forEach(t => t.setAttribute('aria-expanded', 'false'));
      if (!isOpen) {
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
    pill.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !list.hidden) {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
      if (event.key === 'ArrowDown' && document.activeElement === trigger) {
        event.preventDefault();
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        list.querySelector('[role="option"]')?.focus();
      }
    });
  });

  document.addEventListener('click', e => {
    if (!e.target.closest('[data-qcp]')) {
      document.querySelectorAll('[data-qcp-list]').forEach(l => { l.hidden = true; });
      document.querySelectorAll('[data-qcp-trigger]').forEach(t => t.setAttribute('aria-expanded', 'false'));
    }
  });

  const fadeTargets = document.querySelectorAll('.qfade-up-pending');
  if (fadeTargets.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('qfade-up-pending');
          entry.target.classList.add('qfade-up');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -80px 0px', threshold: 0.05 });
    fadeTargets.forEach(el => io.observe(el));
  }
})();

(function () {
  function fixCookieAria() {
    const win = document.querySelector('.cc-window');
    if (!win) return false;
    win.querySelectorAll('a[aria-label], button[aria-label]').forEach(el => {
      const txt = (el.textContent || '').trim();
      if (txt) el.setAttribute('aria-label', txt);
    });
    return true;
  }
  if (!fixCookieAria()) {
    const mo = new MutationObserver(() => {
      if (fixCookieAria()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: false });
    setTimeout(() => mo.disconnect(), 8000);
  }
})();

(function () {
  'use strict';

  if (customElements.get('qenova-cart-drawer')) return;

  const CART_FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const SHOP_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartEndpoint = (path) => `${SHOP_ROOT}${path}`;

  const FREE_SHIP_THRESHOLD = (() => {
    const meta = document.querySelector('meta[name="qenova:free-ship-threshold-cents"]');
    return Math.max(1, meta ? parseInt(meta.content, 10) || 7500 : 7500);
  })();

  function fmt(cents) {
    const shopify = window.Shopify || {};
    try {
      if (shopify.formatMoney && shopify.money_format) {
        return shopify.formatMoney(cents, shopify.money_format);
      }
    } catch (e) {}
    const currency = (shopify.currency && shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency,
      }).format(cents / 100);
    } catch (e) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  }

  class QenovaCartDrawer extends HTMLElement {
    connectedCallback() {
      this.items = this.querySelector('[data-qcd-items]');
      this.footer = this.querySelector('[data-qcd-footer]');
      this.subtotalEl = this.querySelector('[data-qcd-subtotal]');
      this.progressFill = this.querySelector('[data-qcd-progress-fill]');
      this.progressText = this.querySelector('[data-qcd-progress-text]');
      this.panel = this.querySelector('.qcd__panel');
      this.dialog = this.querySelector('.qcd__surface');
      this.bundle = this.querySelector('[data-qcd-bundle]');
      this.bundleList = this.querySelector('[data-qcd-bundle-list]');
      this.bundleCopy = this.querySelector('[data-qcd-bundle-copy]');
      this.bundleRequestId = 0;
      this.recommendationCache = new Map();

      document.addEventListener('cart:open', () => this.open());
      document.addEventListener('qcd:open', () => this.open());
      this.querySelectorAll('[data-qcd-close]').forEach(el =>
        el.addEventListener('click', e => { e.preventDefault(); this.close(); })
      );
      this.dialog?.addEventListener('cancel', e => { e.preventDefault(); this.close(); });
      document.addEventListener('keydown', e => {
        if (this.hidden) return;
        if (e.key === 'Escape') this.close();
        this.trapFocus(e);
      });
    }

    copy(name, fallback) {
      return this.dataset[name] || fallback;
    }

    status(text) {
      const message = document.createElement('p');
      message.className = 'qcd__loading';
      message.textContent = text;
      return message;
    }

    trapFocus(event) {
      if (event.key !== 'Tab' || !this.panel) return;
      const elements = Array.from(this.panel.querySelectorAll(CART_FOCUSABLE)).filter((element) => !element.hidden && element.offsetParent !== null);
      if (!elements.length) {
        event.preventDefault();
        this.panel.focus();
        return;
      }
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    async open() {
      this.returnFocus = document.activeElement;

      // Close Vessel through its component lifecycle. Calling dialog.close()
      // directly skips its scroll-lock cleanup and leaves body position:fixed.
      for (const component of document.querySelectorAll('cart-drawer-component')) {
        const legacyDialog = component.querySelector('dialog[open]');
        if (!legacyDialog) continue;
        if (typeof component.closeDialog === 'function') {
          await component.closeDialog();
        } else if (typeof component.close === 'function') {
          await component.close();
        } else {
          legacyDialog.close();
        }
      }

      this.hidden = false;
      if (this.dialog && !this.dialog.open) {
        try { this.dialog.showModal(); } catch (error) { this.dialog.setAttribute('open', ''); }
      }
      requestAnimationFrame(() => this.setAttribute('data-qcd-open', 'true'));
      document.body.classList.add('qcd-open');
      if (this.items) this.items.replaceChildren(this.status(this.copy('loadingText', 'Wird geladen…')));
      await this.refresh();
      setTimeout(() => { try { this.panel && this.panel.focus(); } catch (e) {} }, 60);
    }

    close() {
      this.setAttribute('data-qcd-open', 'false');
      document.body.classList.remove('qcd-open');
      setTimeout(() => {
        if (this.dialog?.open) this.dialog.close();
        this.hidden = true;
        if (this.returnFocus && typeof this.returnFocus.focus === 'function') this.returnFocus.focus();
      }, 280);
    }

    async refresh() {
      try {
        const r = await fetch(cartEndpoint('cart.js'), { headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error(`Cart request failed: ${r.status}`);
        const cart = await r.json();
        this.render(cart);
        this.fetchBundle(cart);
      } catch (e) {
        console.error('[qenova-cart-drawer]', e);
        if (this.items) this.items.replaceChildren(this.status(this.copy('errorText', 'Warenkorb konnte nicht geladen werden.')));
      }
    }

    render(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = String(cart.item_count || 0);
      });

      this.updateProgress(cart.total_price || 0);

      if (cart.item_count === 0) {
        if (this.items) {
          const empty = document.createElement('div');
          empty.className = 'qcd__empty';
          const emptyText = document.createElement('p');
          emptyText.className = 'qcd__empty-text';
          emptyText.textContent = this.copy('emptyText', 'Ihr Warenkorb ist leer.');
          const continueLink = document.createElement('a');
          continueLink.className = 'qbtn-ghost';
          continueLink.href = this.copy('continueUrl', `${SHOP_ROOT}collections/all`);
          continueLink.textContent = this.copy('continueLabel', 'Weiter einkaufen');
          empty.append(emptyText, continueLink);
          this.items.replaceChildren(empty);
        }
        if (this.footer) this.footer.hidden = true;
        if (this.bundle) this.bundle.hidden = true;
        return;
      }

      if (this.footer) this.footer.hidden = false;
      if (this.subtotalEl) this.subtotalEl.textContent = fmt(cart.total_price);

      if (!this.items) return;
      this.items.innerHTML = '';
      cart.items.forEach(it => this.items.appendChild(this.lineEl(it)));
    }

    updateProgress(totalCents) {
      const pct = Math.min(100, Math.round((totalCents / FREE_SHIP_THRESHOLD) * 100));
      if (this.progressFill) this.progressFill.style.width = pct + '%';
      const remaining = Math.max(0, FREE_SHIP_THRESHOLD - totalCents);
      if (this.progressText) {
        if (remaining === 0) {
          const success = document.createElement('strong');
          success.textContent = this.copy('progressSuccess', 'Kostenloser Versand erreicht! 🎉');
          this.progressText.replaceChildren(success);
        } else {
          const template = this.copy('progressTemplate', 'Du bist [amount] vom kostenlosen Versand entfernt!');
          const parts = template.split('[amount]');
          const amount = document.createElement('strong');
          amount.className = 'qnums';
          amount.textContent = fmt(remaining);
          this.progressText.replaceChildren(document.createTextNode(parts[0] || ''), amount, document.createTextNode(parts.slice(1).join('[amount]') || ''));
        }
      }
    }

    lineEl(it) {
      const article = document.createElement('article');
      article.className = 'qcd__line';
      article.dataset.lineKey = it.key;

      const img = it.featured_image && it.featured_image.url ? it.featured_image.url : '';
      const imgWrap = document.createElement('a');
      imgWrap.className = 'qcd__line-img';
      imgWrap.href = it.url;
      if (img) {
        const imgEl = document.createElement('img');
        imgEl.src = img.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_200x200$1');
        imgEl.alt = it.product_title;
        imgEl.width = 80;
        imgEl.height = 80;
        imgEl.loading = 'lazy';
        imgWrap.appendChild(imgEl);
      }
      article.appendChild(imgWrap);

      const body = document.createElement('div');
      body.className = 'qcd__line-body';
      const title = document.createElement('a');
      title.className = 'qcd__line-title';
      title.href = it.url;
      title.textContent = it.product_title;
      body.appendChild(title);
      if (it.variant_title && it.variant_title !== 'Default Title') {
        const v = document.createElement('div');
        v.className = 'qcd__line-variant';
        v.textContent = it.variant_title;
        body.appendChild(v);
      }
      const qty = document.createElement('div');
      qty.className = 'qcd__line-qty';
      const minus = document.createElement('button');
      minus.type = 'button'; minus.className = 'qcd__line-qty-btn'; minus.setAttribute('aria-label', this.copy('decreaseLabel', 'Verringern'));
      minus.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M5 12h14"/></svg>';
      minus.addEventListener('click', () => this.changeQty(it.key, it.quantity - 1));
      const num = document.createElement('span'); num.className = 'qcd__line-qty-num'; num.textContent = it.quantity;
      const plus = document.createElement('button');
      plus.type = 'button'; plus.className = 'qcd__line-qty-btn'; plus.setAttribute('aria-label', this.copy('increaseLabel', 'Erhöhen'));
      plus.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
      plus.addEventListener('click', () => this.changeQty(it.key, it.quantity + 1));
      qty.appendChild(minus); qty.appendChild(num); qty.appendChild(plus);
      body.appendChild(qty);
      article.appendChild(body);

      const right = document.createElement('div');
      right.className = 'qcd__line-right';
      const trash = document.createElement('button');
      trash.type = 'button'; trash.className = 'qcd__line-remove'; trash.setAttribute('aria-label', this.copy('removeLabel', 'Entfernen'));
      trash.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13M10 11v7M14 11v7"/></svg>';
      trash.addEventListener('click', () => this.changeQty(it.key, 0));
      right.appendChild(trash);
      const stack = document.createElement('div');
      stack.className = 'qcd__line-price-stack';
      if (it.original_price > it.final_price) {
        const cmp = document.createElement('span');
        cmp.className = 'qcd__line-compare';
        cmp.textContent = fmt(it.original_line_price);
        stack.appendChild(cmp);
      }
      const p = document.createElement('span');
      p.className = 'qcd__line-price';
      p.textContent = fmt(it.final_line_price);
      stack.appendChild(p);
      right.appendChild(stack);
      article.appendChild(right);

      return article;
    }

    async changeQty(key, qty) {
      try {
        const response = await fetch(cartEndpoint('cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
        });
        if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);
        await this.refresh();
      } catch (e) { console.error('[qenova-cart change]', e); }
    }

    async fetchBundle(cart) {
      if (!this.bundle || !this.bundleList || cart.item_count === 0) return;
      const requestId = ++this.bundleRequestId;
      const remaining = Math.max(0, FREE_SHIP_THRESHOLD - (cart.total_price || 0));
      if (remaining === 0) {
        this.bundle.hidden = true;
        this.bundleList.replaceChildren();
        return;
      }
      const firstItemProductId = cart.items[0] && cart.items[0].product_id;
      if (!firstItemProductId) return;
      try {
        const products = await this.recommendationProducts(firstItemProductId);
        if (requestId !== this.bundleRequestId) return;

        const cartProductIds = new Set(cart.items.map((item) => String(item.product_id)));
        const maxQuantity = Math.max(1, Math.min(5, Number(this.copy('bundleMaxQuantity', '3')) || 3));
        const candidates = products.flatMap((product) => {
          const variants = (product.variants || []).filter((variant) => variant.available !== false && Number(variant.price) > 0);
          return variants.map((variant) => {
            const unitPrice = Number(variant.price);
            const quantity = Math.max(1, Math.min(maxQuantity, Math.ceil(remaining / unitPrice)));
            const addedTotal = unitPrice * quantity;
            return {
              product,
              variant,
              quantity,
              addedTotal,
              unlocksShipping: addedTotal >= remaining,
              alreadyInCart: cartProductIds.has(String(product.id)),
              sourceRank: Number(product._qcdSourceRank || 3)
            };
          });
        });

        candidates.sort((a, b) => {
          if (a.unlocksShipping !== b.unlocksShipping) return a.unlocksShipping ? -1 : 1;
          if (a.alreadyInCart !== b.alreadyInCart) return a.alreadyInCart ? 1 : -1;
          if (a.unlocksShipping) {
            const overshootDifference = (a.addedTotal - remaining) - (b.addedTotal - remaining);
            if (overshootDifference !== 0) return overshootDifference;
          } else if (a.addedTotal !== b.addedTotal) {
            return b.addedTotal - a.addedTotal;
          }
          if (a.quantity !== b.quantity) return a.quantity - b.quantity;
          return a.sourceRank - b.sourceRank;
        });

        const chosen = [];
        const seenProducts = new Set();
        for (const candidate of candidates) {
          const productId = String(candidate.product.id);
          if (seenProducts.has(productId)) continue;
          seenProducts.add(productId);
          chosen.push(candidate);
          if (chosen.length === 3) break;
        }

        if (!chosen.length) {
          this.bundle.hidden = true;
          this.bundleList.replaceChildren();
          return;
        }
        if (this.bundleCopy) {
          const copyTemplate = this.copy('bundleCopyTemplate', 'Passend zu den fehlenden [amount] ausgewählt.');
          this.bundleCopy.textContent = copyTemplate.replace('[amount]', fmt(remaining));
        }
        this.bundleList.replaceChildren(...chosen.map((candidate) => this.bundleCard(candidate, remaining)));
        this.bundle.hidden = false;
      } catch (e) {
        console.warn('[qenova-cart recommendations]', e);
        this.bundle.hidden = true;
      }
    }

    async recommendationProducts(productId) {
      const cacheKey = String(productId);
      if (this.recommendationCache.has(cacheKey)) return this.recommendationCache.get(cacheKey);

      const fetchRecommendations = async (intent, sourceRank) => {
        const url = `${cartEndpoint('recommendations/products.json')}?product_id=${encodeURIComponent(productId)}&intent=${intent}&limit=10`;
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) return [];
        const data = await response.json();
        return (data.products || []).map((product) => ({ ...product, _qcdSourceRank: sourceRank }));
      };

      const [complementary, related] = await Promise.all([
        fetchRecommendations('complementary', 1),
        fetchRecommendations('related', 2)
      ]);
      let products = [...complementary, ...related];

      if (products.length < 6) {
        const response = await fetch(`${SHOP_ROOT}collections/all/products.json?limit=24`, { headers: { Accept: 'application/json' } });
        if (response.ok) {
          const data = await response.json();
          products.push(...(data.products || []).map((product) => ({ ...product, _qcdSourceRank: 3 })));
        }
      }

      const unique = [];
      const seen = new Set();
      products.forEach((product) => {
        const key = String(product.id || product.handle || '');
        if (!key || seen.has(key) || !Array.isArray(product.variants)) return;
        if (!product.variants.some((variant) => variant.available !== false && Number(variant.price) > 0)) return;
        seen.add(key);
        unique.push(product);
      });
      this.recommendationCache.set(cacheKey, unique);
      return unique;
    }

    bundleCard(candidate, remaining) {
      const { product, variant, quantity, addedTotal, unlocksShipping } = candidate;
      const card = document.createElement('article');
      card.className = 'qcd__bundle-card';

      const mediaLink = document.createElement('a');
      mediaLink.className = 'qcd__bundle-img';
      mediaLink.href = product.url || `${SHOP_ROOT}products/${product.handle}`;
      if (product.featured_image) {
        const image = document.createElement('img');
        image.src = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
        image.alt = product.title || '';
        image.width = 64;
        image.height = 64;
        image.loading = 'lazy';
        mediaLink.appendChild(image);
      }

      const body = document.createElement('div');
      const title = document.createElement('a');
      title.className = 'qcd__bundle-name';
      title.href = mediaLink.href;
      title.textContent = product.title || '';
      const subtitle = document.createElement('div');
      subtitle.className = 'qcd__bundle-sub';
      subtitle.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : (product.type || '');
      const price = document.createElement('div');
      price.className = 'qcd__bundle-price';
      price.textContent = quantity > 1 ? `${quantity} × ${fmt(Number(variant.price))} · ${fmt(addedTotal)}` : fmt(addedTotal);
      const unlock = document.createElement('span');
      unlock.className = 'qcd__bundle-unlock';
      if (unlocksShipping) {
        unlock.textContent = this.copy('bundleUnlock', 'Schaltet kostenlosen Versand frei');
      } else {
        const progressTemplate = this.copy('bundleProgressTemplate', 'Bringt dich [amount] näher ans Ziel');
        unlock.textContent = progressTemplate.replace('[amount]', fmt(Math.min(remaining, addedTotal)));
      }
      body.append(title, subtitle, price, unlock);

      const add = document.createElement('button');
      add.type = 'button';
      add.className = 'qcd__bundle-add';
      add.textContent = quantity > 1
        ? this.copy('bundleQuantityTemplate', '[quantity] hinzufügen').replace('[quantity]', String(quantity))
        : this.copy('bundleAdd', 'Hinzufügen');
      add.addEventListener('click', () => this.addBundleVariant(variant.id, quantity, add));

      card.append(mediaLink, body, add);
      return card;
    }

    async addBundleVariant(variantId, quantity, button) {
      button.disabled = true;
      try {
        const response = await fetch(cartEndpoint('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: Math.max(1, quantity || 1) }] })
        });
        if (!response.ok) throw new Error(`Add-on failed: ${response.status}`);
        await this.refresh();
      } catch (error) {
        console.error('[qenova-cart add-on]', error);
        button.disabled = false;
      }
    }
  }

  customElements.define('qenova-cart-drawer', QenovaCartDrawer);

  document.addEventListener('click', function (e) {
    const a = e.target.closest('a[href="/cart"], a[href$="/cart"], a[href*="/cart?"]');
    if (!a) return;
    if (a.closest('[data-no-drawer]')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('qcd:open'));
  }, true);
})();
